import classNames from "classnames";

import { BoldText } from "components/BoldText/BoldText";
import { BaseLayout } from "components/BaseLayout/BaseLayout";

import styles from "./styles.module.scss";
import { PrintTemplatesFooter, PrintTemplatesBody } from "./components";

const Header = (): JSX.Element => (
  <BoldText>Шаблоны для печати документов</BoldText>
);

export const PrintTemplates = (): JSX.Element => (
  <BaseLayout
    className={classNames("ml-2 mt-3 mb-3", styles.container)}
    header={<Header />}
    footer={<PrintTemplatesFooter />}
  >
    <PrintTemplatesBody />
  </BaseLayout>
);
